import { combineReducers } from 'redux'
import search from './search'
import all from './all'


export default combineReducers({
  search,
  all
})
